export default __webpack_public_path__ + "static/media/quota-consumption-alert.e5a88ddd.png";